import React from 'react';
import { Button } from './ui/Button';
export function Hero() {
  return <section className="relative w-full py-24 md:py-32 lg:py-40 px-4 overflow-hidden" data-id="element-76">
      <div className="max-w-4xl mx-auto text-center" data-id="element-77">
        <div className="space-y-2 md:space-y-4 mb-8 md:mb-12" data-id="element-78">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-[#1a1a1a] tracking-tight leading-tight" data-id="element-79">
            <span className="block" data-id="element-80">Celebrate.</span>
            <span className="block text-[#1e5631]" data-id="element-81">Honor.</span>
            <span className="block" data-id="element-82">Support.</span>
          </h1>
        </div>

        <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-83">
          Recognizing and inspiring great fathers in our community through essays written by
          their children.
        </p>

        <div className="flex justify-center" data-id="element-84">
          <Button href="#flyer" className="text-lg px-8 py-4" data-id="element-85">
            View Submission Flyer
          </Button>
        </div>
      </div>
    </section>;
}